import { useQuery } from "@tanstack/react-query";

import { getPriceSettingsOptions } from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export const useGetPriceSettings = () => {
  return useQuery({
    ...getPriceSettingsOptions(),
  });
};
